import { EntityErrors, isFieldErrorsValid, NoFieldError, ValidatableEntity } from "../validation/validatableentity";
import { Validator } from "../validation/validator";
import { Container as Container } from "./types";

function getEntityField<S extends ValidatableEntity<any>>(
    draft_state: S,
    field: string,
    default$: any = null
): any {
    const field_path = field.split('.');

    let draft_item: Container = draft_state.entity;
    for (const field_item of field_path) {
        draft_item = draft_item[field_item];
        if (draft_item == null) {
            break;
        }
    }

    return draft_item == null ?
        default$ :
        draft_item;
};

function setFieldNotValidate<S extends Container>(
    draft_state: S,
    field: string,
    value: boolean | string | number
) {
    const field_path = field.split('.');
    const field_path_len = field_path.length;
    if (field_path_len === 0) {
        return;
    }

    const last_field_index = field_path_len - 1;

    let draft_item: Container = draft_state;
    for (let i = 0; i < last_field_index; ++i) {
        const field_item = field_path[i];
        draft_item = draft_item[field_item];
        if (draft_item == null) {
            break;
        }
    }

    if (draft_item != null) {
        let field_item = field_path[last_field_index];
        draft_item[field_item] = value;
    }
}

function validateAndTestIfStore(
    draft_errors: EntityErrors,
    field: string,
    value: boolean | number | string,
    validator: Validator<any> = null,
    storeInvalidValue: boolean = true): boolean {
    let validate = validator !== null;
    let errors = validate ?
        validator(value) :
        { ...NoFieldError };
    draft_errors[field] = errors;

    return false ||
        !validate ||
        storeInvalidValue ||
        isFieldErrorsValid(errors);
}

function setStateField<S extends Container>(
    draft_state: S,
    field: string,
    value: boolean | string | number,
    validator: Validator<any> = null,
    storeInvalidValue: boolean = true
) {
    const storeValue = validateAndTestIfStore(
        draft_state.errors,
        field, value,
        validator, storeInvalidValue);
    if (storeValue) {
        setFieldNotValidate(draft_state, field, value);
    }
}

function setEntityFieldNotValidate<State extends ValidatableEntity<any>>(
    draft_state: State,
    field: string,
    value: boolean | string | number
) {
    setFieldNotValidate(draft_state.entity, field, value);
}

function setEntityField<State extends ValidatableEntity<any>>(
    draft_state: State,
    field: string,
    value: boolean | string | number,
    validator: Validator<any> = null,
    storeInvalidValue: boolean = true
) {
    const storeValue = validateAndTestIfStore(
        draft_state.errors,
        field, value,
        validator, storeInvalidValue);
    if (storeValue) {
        setFieldNotValidate(draft_state.entity, field, value);
    }
}

export {
    getEntityField,
    setEntityFieldNotValidate,
    setEntityField,
    setStateField
}